/** Canonical web frontend URLs. Legacy chat.* hosts kept during migration. */

export const PROD_FRONTEND_URL = "https://rotogpt.com";
export const DEV_FRONTEND_URL = "https://dev.rotogpt.com";

const LEGACY_DEV_HOST = "chat.dev.rotogpt.com";
const LEGACY_PROD_HOST = "chat.rotogpt.com";

const DEV_HOST_MARKERS = [DEV_FRONTEND_URL, LEGACY_DEV_HOST] as const;

export const DEV_FRONTEND_URIS: readonly string[] = [
  // "http://localhost:3000",
  // "http://localhost:3000/",
  // "http://localhost:3000/home",
  // Dev hosts
  DEV_FRONTEND_URL,
  `${DEV_FRONTEND_URL}/`,
  `${DEV_FRONTEND_URL}/home`,
  `https://${LEGACY_DEV_HOST}`,
  `https://${LEGACY_DEV_HOST}/`,
  `https://${LEGACY_DEV_HOST}/home`,
  // Prod hosts (IF YOU COMMENT OUT THIS PROD LINES, IN PROD WEB YOU WILL NOT SEE THE AUTH SIGN)
  // PROD_FRONTEND_URL,
  // `${PROD_FRONTEND_URL}/`,
  // `${PROD_FRONTEND_URL}/home`,
  // `https://${LEGACY_PROD_HOST}`,
  // `https://${LEGACY_PROD_HOST}/`,
  // `https://${LEGACY_PROD_HOST}/home`,
];

export const isDevFrontendEnv = (configuredFrontendUri = process.env.REACT_APP_FRONTEND_URI_WEB || ""): boolean =>
  DEV_HOST_MARKERS.some((host) => configuredFrontendUri.includes(host));

/** Public paths exempt from the web-only login gate (Capacitor Browser + legal pages). */
export const WEB_LOGIN_GATE_PUBLIC_PATHS = [
  "/terms-conditions",
  "/terms-and-conditions",
  "/privacy-policy",
  "/contact",
  "/stripe-return",
  "/articles",
  "/faq",
  "/glossary",
] as const;

/** Check if the current path is a public path for the web login dialog gate */
export const isWebLoginGatePublicPath = (pathname: string): boolean =>
  WEB_LOGIN_GATE_PUBLIC_PATHS.some((path) => pathname === path || pathname === `${path}/`) ||
  pathname.startsWith("/articles/");

export const getProdFrontendFallbackUrl = (): string => PROD_FRONTEND_URL;

/** Deep link to a published article on the public /articles page (email, share, etc.). */
export const buildArticleDeepLinkUrl = (articleSlug: string, baseUrl = PROD_FRONTEND_URL): string =>
  `${baseUrl.replace(/\/$/, "")}/articles/${encodeURIComponent(articleSlug.trim())}`;

/** Legacy ?id= deep links — kept for backward compatibility with old emails/shares. */
export const buildArticleLegacyDeepLinkUrl = (articleSlug: string, baseUrl = PROD_FRONTEND_URL): string =>
  `${baseUrl.replace(/\/$/, "")}/articles?id=${encodeURIComponent(articleSlug.trim())}`;

/** Clickable web URL patterns in help content (legacy + canonical). */
export const WEB_FRONTEND_LINK_PATTERNS = [
  { pattern: /rotogpt\.com/g, url: PROD_FRONTEND_URL },
  { pattern: /chat\.rotogpt\.com/g, url: PROD_FRONTEND_URL },
] as const;
